import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "@/components/Navigation";
import HeroVideo from "@/components/HeroVideo";
import HeroTiles from "@/components/HeroTiles";
import About from "@/components/About";
import GamePlanPromo from "@/components/GamePlanPromo";
import SocialVideos from "@/components/SocialVideos";
import Testimonials from "@/components/Testimonials";
import FeaturedListings from "@/components/FeaturedListings";
import SoldListings from "@/components/SoldListings";
import Contact from "@/components/Contact";
import Team from "@/components/Team";
import BlogTeaser from "@/components/BlogTeaser";
import Footer from "@/components/Footer";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    // Wait a tick for sections to mount, then scroll
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <main data-testid="home-page" className="bg-white text-black">
      <Navigation />
      <HeroVideo />
      <HeroTiles />
      <About />
      <GamePlanPromo />
      <SocialVideos />
      <Testimonials />
      <FeaturedListings />
      <SoldListings />
      <Team />
      <Contact />
      <BlogTeaser />
      <Footer />
    </main>
  );
};

export default Home;
